export const editorThemeColors = {
    background: "var(--color-editor-background)",
    neutral1: "var(--color-editor-neutral-1)",
    neutral2: "var(--color-editor-neutral-2)",
    neutral3: "var(--color-editor-neutral-3)",
    inputBar: "var(--color-editor-input-bar)",
    selected: "var(--color-editor-selected)",
};
